<template>
  <div>
    <template v-if="score">
      <v-layout align-center>
        <v-flex shrink style="width: 60px" class="text-xs-center">
          {{ minScore }}
        </v-flex>
        <v-flex>
          <v-range-slider
            v-model="score"
            :max="maxScore * 100"
            :min="minScore * 100"
            :step="1"
            thumb-label="always"
          >
            <template #thumb-label="item"> {{ item.value / 100 }} </template>
          </v-range-slider>
        </v-flex>
        <v-flex shrink style="width: 60px" class="text-xs-center">
          {{ maxScore }}
        </v-flex>
      </v-layout>

      <div class="text-xs-center">
        <v-btn color="grey" outline @click="handleCancel">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" @click="handleSave">{{ $t('Save') }}</v-btn>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['trainingConfig', 'maxScore', 'minScore'],
  data() {
    return {
      maxScoreValue: 0,
      minScoreValue: 0,
      score: null
    }
  },
  mounted() {
    if (this.trainingConfig) {
      this.score = [this.trainingConfig.min_score * 100, this.trainingConfig.max_score * 100]
    }
  },
  methods: {
    handleCancel() {
      this.$emit('onCancel')
    },
    handleSave() {
      if (!this.score) return false
      this.$emit('onSaveTrainingConfig', {
        ...this.trainingConfig,
        min_score: this.score[0] / 100,
        max_score: this.score[1] / 100
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Training/TrainingScoreSetting.vue